import { Routes } from "@angular/router";

export const ORDER_ROUTES: Routes = [
  {
    path: "list",
    loadComponent: () =>
      import("./pages/order-list/order-list.component").then(
        (m) => m.OrderListComponent,
      ),
    title: "Orders - Foresight",
    data: {
      breadcrumb: "Overview",
      breadcrumbModule: "Orders",
      breadcrumbTrail: [{ label: "Overview", reload: true }],
      pageId: "list-orders",
    },
  },
  {
    path: "view/:id",
    loadComponent: () =>
      import("./pages/view-order/view-order.component").then(
        (m) => m.ViewOrderComponent,
      ),
    title: "Order Details - Foresight",
    data: {
      breadcrumb: "Order Details",
      breadcrumbModule: "Orders",
      breadcrumbTrail: [
        { label: "Overview", route: "/order/list" },
        { type: "detail", param: "id", prefix: "Order " },
      ],
      pageId: "order-details",
    },
  },
  { path: "", redirectTo: "list", pathMatch: "full" },
];
